import realauth from './realauth'
import preApntd from './preApntd'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    realauth,
    preApntd,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js